// Icon mapping (same as templates page)
import {
  ClipboardList,
  MessageSquare,
  Briefcase,
  FileSpreadsheet,
  Users,
  BookOpen,
  UserPlus,
  Building2,
  HeartPulse,
  Phone,
  ShoppingCart,
  Puzzle,
  Workflow,
  Mail,
  AlertTriangle,
  Database,
  Clock,
  Headphones,
  Zap,
  ArrowUpCircle,
  ScanLine,
  Tags,
  FileStack,
  Receipt,
  ScanText,
  CheckCircle,
  Building,
  UserCircle,
  GitBranch,
  HardDrive,
  AlertCircle,
  Search,
  ListChecks,
  Key,
  CheckSquare,
  ListTodo,
  GraduationCap,
  Calculator,
  GitCompare,
  UserCheck,
  FileCheck,
  LucideIcon,
  Ticket,
  Headset,
  NotebookPen,
  FileText,
  Book,
  Brain,
  Calendar,
  FileUp,
  Send,
  User,
} from "lucide-react";

const ICON_MAP: Record<string, LucideIcon> = {
  ClipboardList,
  MessageSquare,
  Briefcase,
  FileText,
  FileSpreadsheet,
  Users,
  BookOpen,
  UserPlus,
  Building2,
  HeartPulse,
  Phone,
  ShoppingCart,
  Puzzle,
  Workflow,
  Mail,
  AlertTriangle,
  Database,
  Clock,
  Headphones,
  Zap,
  ArrowUpCircle,
  ScanLine,
  Tags,
  FileStack,
  Receipt,
  ScanText,
  CheckCircle,
  Building,
  UserCircle,
  GitBranch,
  HardDrive,
  AlertCircle,
  Search,
  ListChecks,
  Key,
  CheckSquare,
  ListTodo,
  GraduationCap,
  Calculator,
  GitCompare,
  UserCheck,
  FileCheck,
  Ticket,
  Headset,
  NotebookPen,
  Book,
  Brain,
  Calendar,
  FileUp,
  Send,
  User,
};

export const getIconComponent = (
  iconName: string | null | undefined
): LucideIcon => {
  if (!iconName) return Puzzle;
  return ICON_MAP[iconName] || Puzzle;
};
